// TODO: Dodać proxy na web komponenty i pozbyć się tego. typy
(window as any).__zone_symbol__UNPATCHED_EVENTS = ['insValidation', 'insStyle', 'insTableHeaderResizeStart', 'insTableHeaderResizeStop'];
